module.exports = __webpack_public_path__ + "img/icon_attendance.7250f06b.svg";